import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// usuarios a bloquear
const blockedUsers = new Set([16, 17, 18, 2015]);

try {
  const raw = localStorage.getItem("user");
  if (raw) {
    const user = JSON.parse(raw);
    const uid = Number(user?.user_id);

    if (blockedUsers.has(uid)) {
      console.log("Usuario bloqueado:", uid);

      // borra SOLO auth (mejor que clear)
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("refresh_token"); // si tienes
    }
  }
} catch (e) {
  console.error("Error leyendo storage:", e);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();